module.exports = __webpack_public_path__ + "static/img/blue-2.5e1f85f9.jpg";